import React, { useEffect, useRef, useState } from "react";

const RoasterVideoPlayer = () => {
  const videoRef = useRef(null);
  const containerRef = useRef(null);
  const [videoList, setVideoList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [error, setError] = useState(null);

  // Fetch video list
  useEffect(() => {
    fetch("https://ricgop.online/backend/videos.php")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch video list");
        return res.json();
      })
      .then((data) => {
        console.log("Video list:", data);
        if (Array.isArray(data) && data.length > 0) {
          setVideoList(data);
        } else {
          throw new Error("No valid videos found");
        }
      })
      .catch((err) => {
        console.error("Video loading error:", err);
        setError(err.message);
      });
  }, []);

  // Attempt to go fullscreen and handle video looping
  useEffect(() => {
    const video = videoRef.current;
    const container = containerRef.current;

    if (video && videoList.length > 0) {
      // Small delay to improve fullscreen success rate
      setTimeout(() => {
        if (container.requestFullscreen) {
          container.requestFullscreen().catch((err) => {
            console.warn("Fullscreen denied:", err);
          });
        } else if (container.webkitRequestFullscreen) {
          container.webkitRequestFullscreen();
        } else if (container.msRequestFullscreen) {
          container.msRequestFullscreen();
        }

        video.play().catch((err) => {
          console.warn("Autoplay failed:", err);
        });
      }, 300); // small delay increases chance of success

      const handleEnded = () => {
        setCurrentIndex((prev) => (prev + 1) % videoList.length);
      };

      video.addEventListener("ended", handleEnded);
      return () => video.removeEventListener("ended", handleEnded);
    }
  }, [videoList, currentIndex]);

  if (error) {
    return <div style={{ color: "red", padding: "2rem" }}>Error: {error}</div>;
  }

  if (videoList.length === 0) {
    return <div style={{ padding: "2rem" }}>Loading videos...</div>;
  }

  return (
    <div
      ref={containerRef}
      style={{
        width: "100vw",
        height: "100vh",
        margin: 0,
        padding: 0,
        overflow: "hidden",
        backgroundColor: "black",
      }}
    >
      <video
        ref={videoRef}
        src={videoList[currentIndex]}
        autoPlay
        muted
        playsInline
        controls={false}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
        onError={() => {
          console.error("Failed to load video:", videoList[currentIndex]);
          setCurrentIndex((prev) => (prev + 1) % videoList.length);
        }}
      />
    </div>
  );
};

export default RoasterVideoPlayer;
